import { Button } from '@circlefin/components'
import { usePermission } from '@circlefin/permissions/react'
import {
  CIRCLE_WALLETS_MUTATION,
  CIRCLE_WALLETS_QUERY,
} from '@services/permissions'
import {
  useWalletApprovalPolicyQuery,
  WalletApprovalPolicyState,
} from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

import type { ButtonProps } from '@circlefin/components/lib/Button'
import type { Currency } from '@shared/graphql'

export interface SubmitDraftProps extends ButtonProps {
  /**
   * Currency.
   */
  currency: Currency
}

export const SubmitDraft: React.FC<SubmitDraftProps> = ({
  currency,
  disabled = false,
  ...rest
}) => {
  const { t } = useTranslation('walletApprovalPolicy')

  const [, { isAuthorized: isAuthorizedForQuery }] =
    usePermission(CIRCLE_WALLETS_QUERY)
  const [{ Authorized }] = usePermission(CIRCLE_WALLETS_MUTATION)

  const walletApprovalPolicyQuery = useWalletApprovalPolicyQuery({
    variables: {
      currency,
    },
    skip: !isAuthorizedForQuery,
  })

  if (
    walletApprovalPolicyQuery.data?.walletApprovalPolicy?.state !==
    WalletApprovalPolicyState.DRAFT
  ) {
    return null
  }

  return (
    <Authorized>
      <Button disabled={disabled} size="sm" {...rest}>
        {t`buttons.submitForApproval`}
      </Button>
    </Authorized>
  )
}
